import logo from "./logo.svg";
import "./App.css";
import ThermalPrinter from "./ThermalPrinter";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <ThermalPrinter />
      </header>
    </div>
  );
}

export default App;
